'use strict';

var createBucketsFn = require('./fn-buckets').createBucketsFn;

var FN_NAME = 'quantiles';

module.exports = function (datasource) {
  return createBucketsFn(datasource, FN_NAME, '>');
};

module.exports.fnName = FN_NAME;



//////////////////
// WEBPACK FOOTER
// ./~/turbo-carto/src/fn/fn-buckets-quantiles.js
// module id = 2090
// module chunks = 6